import { StateSchema } from 'app/config/storeConfig/types';
import { MapConfig } from '../mapConfigSerialization';

export const getMapConfig = (state: StateSchema): MapConfig => state.warehouseMapConstructor.mapConfig;
